import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLanguage } from "../i18n/LanguageContext";
import { getConsent, grantConsent } from "../analytics";

// Banner de consentimento de cookies (RGPD + nLPD suíço).
// É o único elemento visual novo — exigência legal para ativar o tracking de marketing.
export const ConsentBanner = () => {
    const { t } = useLanguage();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (getConsent() === null) setVisible(true);
    }, []);

    const choose = (accepted) => {
        grantConsent(accepted);
        setVisible(false);
    };

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    initial={{ y: 90, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 90, opacity: 0 }}
                    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed bottom-0 inset-x-0 z-[80] border-t border-[#c9a24b]/30 bg-[#0a0705]/95 backdrop-blur-md"
                    data-testid="consent-banner"
                    role="dialog"
                    aria-label={t.consent.titulo}
                >
                    <div className="mx-auto max-w-[1400px] px-5 sm:px-10 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
                        <p className="font-light text-xs sm:text-sm text-[#efe6d6]/75 text-center sm:text-left leading-relaxed" data-testid="consent-text">
                            {t.consent.texto}{" "}
                            <Link to="/privacidade" className="text-[#c9a24b] underline underline-offset-4 decoration-[#c9a24b]/40 hover:decoration-[#c9a24b] transition-[text-decoration-color] duration-300" data-testid="consent-link">
                                {t.consent.saberMais}
                            </Link>
                        </p>
                        <div className="flex items-center gap-3 shrink-0">
                            <button
                                onClick={() => choose(false)}
                                data-testid="consent-reject"
                                className="font-caps text-[10px] tracking-[0.25em] uppercase text-[#efe6d6]/70 border border-[#efe6d6]/25 px-5 py-2.5 hover:border-[#efe6d6]/60 transition-colors duration-300"
                            >
                                {t.consent.rejeitar}
                            </button>
                            <button
                                onClick={() => choose(true)}
                                data-testid="consent-accept"
                                className="font-caps text-[10px] tracking-[0.25em] uppercase text-[#070503] bg-[#c9a24b] px-5 py-2.5 hover:bg-[#ecd49b] transition-colors duration-300"
                            >
                                {t.consent.aceitar}
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
